import axios from "axios";
import Links from "@/shared/constants/Links";

const base = Links.programmeAccreditations;

const ProgrammeAccreditations = {
  list: schoolId => axios.get(base, {
    params: schoolId == null ? {} : { schoolId }
  }),
  getForProgramme: programmeId => axios.get(`${base}/programme/${programmeId}`),
  saveForProgramme: (programmeId, request) =>
    axios.put(`${base}/programme/${programmeId}`, request)
};

export default ProgrammeAccreditations;
